import { render, staticRenderFns } from "./DepositLimitModal.vue?vue&type=template&id=41be95bc&"
import script from "./DepositLimitModal.vue?vue&type=script&lang=js&"
export * from "./DepositLimitModal.vue?vue&type=script&lang=js&"
import style0 from "./DepositLimitModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports